import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const GlassCard = ({ children, className = "", testId, delay = 0 }) => (
  <motion.div
    data-testid={testId}
    custom={delay}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    variants={fadeUp}
    className={`glass-panel rounded-2xl ${className}`}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, highlight, description, align = "left", testId }) => (
  <motion.div
    data-testid={testId}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    variants={fadeUp}
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
  >
    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-amber-400 mb-4">{eyebrow}</p>
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
      {title} {highlight && <span className="gold-text">{highlight}</span>}
    </h2>
    {description && <p className="mt-5 text-base md:text-lg text-slate-400 leading-relaxed">{description}</p>}
  </motion.div>
);
